import { Heading, HStack, VStack } from '@chakra-ui/react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type TenantLeasingProps = {
  children?: React.ReactNode;
};

export const TenantLeasing: React.FC<TenantLeasingProps> = () => {
  const { property } = usePropertiesModel();
  if (!property?.sfr?.status.tenant_leasing.data) return null;
  const title = 'Tenant Leasing Process';
  const { data } = property.sfr.status.tenant_leasing;
  const _id = title.toLowerCase().replace(' ', '-');
  return (
    <VStack alignItems={['center', 'flex-start']}>
      <Heading
        id={_id}
        letterSpacing={-0.8}
        fontWeight={'normal'}
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontSize={['28px', '36px']}>
        {title}
      </Heading>
      {data.map((item) => (
        <HStack
          key={`${item.title}`}
          lineHeight={['40px', '40px', '84px']}
          w="full"
          justifyContent={'space-between'}
          borderBottomWidth={1}
          borderBottomColor={'gray.200'}>
          <TextBlock color="gray.500" fontSize={[14, 14, 20]}>
            {item.title}
          </TextBlock>
          <TextBlock fontSize={[14, 14, 20]} weight="bold">
            {item.description}
          </TextBlock>
        </HStack>
      ))}
    </VStack>
  );
};
